import React from 'react';
import { Box, Container, Heading, Image, Link } from '@chakra-ui/react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import client1 from '../../assets/images/Clients/elalandscapeLogo.webp';
import client2 from '../../assets/images/Clients/elalandscapeLogo.webp';
// import client3 from '../../assets/images/Clients/3-white.png';
// import client4 from '../../assets/images/Clients/4-white.png';
// import client5 from '../../assets/images/Clients/5-white.png';
// import client6 from '../../assets/images/Clients/6-white.png';
// import client7 from '../../assets/images/Clients/7-white.png';

const clients = [
  { id: 1, src: client1, alt: 'Client 1' },
  { id: 2, src: client2, alt: 'Client 2' },
  { id: 3, src: client2, alt: 'Client 2' },
  { id: 4, src: client2, alt: 'Client 2' },
  { id: 5, src: client2, alt: 'Client 2' },
  { id: 6, src: client2, alt: 'Client 2' },
  // { id: 3, src: client3, alt: 'Client 3' },
  // { id: 4, src: client4, alt: 'Client 4' },
  // { id: 5, src: client5, alt: 'Client 5' },
  // { id: 6, src: client6, alt: 'Client 6' },
  // { id: 7, src: client7, alt: 'Client 7' },
];

function OurClients() {
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <Box as="section" py={20} id="our-clients" bg="gray.50">
      <Container maxW="7xl">
        <Heading
          as="h2"
          size="xl"
          textAlign="center"
          mb={12}
          color="gray.800"
        >
          Trusted by Over 500 Clients Around the World
        </Heading>
        <Slider {...settings}>
          {clients.map((client) => (
            <Box
              key={client.id}
              px={4}
              display="flex"
              justifyContent="center"
              alignItems="center"

            >
              <Link
                href="#0"
                _hover={{ transform: 'scale(1.05)', transition: 'transform 0.3s' }}
              >
                <Image
                  src={client.src}
                  alt={client.alt}
                  p={2}
                  maxW="150px"
                  objectFit="contain"
                  loading="lazy"
                  bg={'white'}
                  borderRadius={'10px'}
                  // boxShadow={'lg'}
                  _hover={{ boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px' }}
                />
              </Link>
            </Box>
          ))}
        </Slider>
      </Container>
    </Box>
  );
}

export default OurClients;